export const suggestServiceCtx = {
  filter: {
    addresses: 'addresses',
    places: 'places',
    all: 'all'
  },
  type: {
    address: 'address',
    poi: 'poi',
    store_chain: 'store_chain',
    rubric: 'rubric'
  }
}
